var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.bannerShouldShow,
          expression: "bannerShouldShow",
        },
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.handleScroll,
          expression: "handleScroll",
        },
      ],
      class:
        "cookie-banner " +
        (_vm.accepted && !_vm.acceptComplete ? "hiding" : ""),
    },
    [
      _c("div", { staticClass: "inner is-beige is-tablet-regular" }, [
        _c(
          "div",
          [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.descriptionTemplate) },
            }),
            _c(
              "router-link",
              {
                staticClass: "underline link is-beige",
                attrs: { title: "Privacy Policy", to: "/privacy-policy/" },
              },
              [_vm._v("privacy policy")]
            ),
            _vm._v("."),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "is-tablet-bold is-beige", on: { click: _vm.accept } },
          [
            _c("span", { staticClass: "underlined-link beige-to-red" }, [
              _vm._v("I Agree"),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }